"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const idsTheme_1 = __importDefault(require("../idsTheme"));
const ItauTextPro_W_XBd_woff2_1 = __importDefault(require("../../../assets/fonts/itau_text/WOFF2/ItauTextPro_W_XBd.woff2"));
const ItauTextPro_W_Bd_woff2_1 = __importDefault(require("../../../assets/fonts/itau_text/WOFF2/ItauTextPro_W_Bd.woff2"));
const ItauTextPro_W_Lt_woff2_1 = __importDefault(require("../../../assets/fonts/itau_text/WOFF2/ItauTextPro_W_Lt.woff2"));
const ItauTextPro_W_Rg_woff2_1 = __importDefault(require("../../../assets/fonts/itau_text/WOFF2/ItauTextPro_W_Rg.woff2"));
const ItauTextPro_W_XBd_woff_1 = __importDefault(require("../../../assets/fonts/itau_text/WOFF/ItauTextPro_W_XBd.woff"));
const ItauTextPro_W_Bd_woff_1 = __importDefault(require("../../../assets/fonts/itau_text/WOFF/ItauTextPro_W_Bd.woff"));
const ItauTextPro_W_Lt_woff_1 = __importDefault(require("../../../assets/fonts/itau_text/WOFF/ItauTextPro_W_Lt.woff"));
const ItauTextPro_W_Rg_woff_1 = __importDefault(require("../../../assets/fonts/itau_text/WOFF/ItauTextPro_W_Rg.woff"));
const ItauDisplayPro_W_XBd_woff2_1 = __importDefault(require("../../../assets/fonts/itau_display/WOFF2/ItauDisplayPro_W_XBd.woff2"));
const ItauDisplayPro_W_Bd_woff2_1 = __importDefault(require("../../../assets/fonts/itau_display/WOFF2/ItauDisplayPro_W_Bd.woff2"));
const ItauDisplayPro_W_Lt_woff2_1 = __importDefault(require("../../../assets/fonts/itau_display/WOFF2/ItauDisplayPro_W_Lt.woff2"));
const ItauDisplayPro_W_Rg_woff2_1 = __importDefault(require("../../../assets/fonts/itau_display/WOFF2/ItauDisplayPro_W_Rg.woff2"));
const ItauDisplayPro_W_XBd_woff_1 = __importDefault(require("../../../assets/fonts/itau_display/WOFF/ItauDisplayPro_W_XBd.woff"));
const ItauDisplayPro_W_Bd_woff_1 = __importDefault(require("../../../assets/fonts/itau_display/WOFF/ItauDisplayPro_W_Bd.woff"));
const ItauDisplayPro_W_Lt_woff_1 = __importDefault(require("../../../assets/fonts/itau_display/WOFF/ItauDisplayPro_W_Lt.woff"));
const ItauDisplayPro_W_Rg_woff_1 = __importDefault(require("../../../assets/fonts/itau_display/WOFF/ItauDisplayPro_W_Rg.woff"));
const defaultTheme = (0, idsTheme_1.default)();
const reset = `
  /* Box sizing rules */
  *,
  *::before,
  *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  /* Remove default padding, list styles on ul, ol elements with a class attribute */
  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  main,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  dialog,
  video {
    border: 0;
    font: inherit;
    font-size: 100%;
    margin: 0;
    padding: 0;
    vertical-align: baseline;
  }

  /* Remove default margin */
  body,
  h1,
  h2,
  h3,
  h4,
  p,
  ul,
  ol,
  li,
  figure,
  figcaption,
  blockquote,
  dl,
  dd {
    margin: 0;
  }

  /* Set core body defaults */
  body {
    line-height: 1.5;
    min-height: 100vh;
    scroll-behavior: smooth;
    text-rendering: optimizeSpeed;
  }

  /* A elements that don't have a class get default styles */
  a:not([class]) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  img {
    display: block;
    max-width: 100%;
  }

  /* Natural flow and rhythm in articles by default */
  article > * + * {
    margin-top: 1em;
  }

  /* Inherit fonts for inputs and buttons */
  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  /* Remove all animations and transitions for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms;
      animation-iteration-count: 1;
      scroll-behavior: auto;
      transition-duration: 0.01ms;
    }
  }
`;
exports.default = (0, styled_components_1.createGlobalStyle) `

  ${reset}

  @font-face {
    font-display: swap;
    font-family: 'Itau Text';
    font-style: 'light';
    font-weight: 200;
    src: local('Itau Text'), local('Itau Text'),
      url(${ItauTextPro_W_Lt_woff_1.default}) format('woff2'),
      url(${ItauTextPro_W_Lt_woff2_1.default}) format('woff');
  }

  @font-face {
    font-display: swap;
    font-family: 'Itau Text';
    font-style: 'regular';
    font-weight: 400;
    src: local('Itau Text'), local('Itau Text'),
      url(${ItauTextPro_W_Rg_woff_1.default}) format('woff2'),
      url(${ItauTextPro_W_Rg_woff2_1.default}) format('woff');
  }

  @font-face {
    font-family: 'Itau Text';
    font-style: 'bold';
    font-weight: 700;
    src: local('Itau Text'), local('Itau Text'),
      url(${ItauTextPro_W_Bd_woff_1.default}) format('woff2'),
      url(${ItauTextPro_W_Bd_woff2_1.default}) format('woff');
  }

  @font-face {
    font-display: swap;
    font-family: 'Itau Text';
    font-style: 'xbold';
    font-weight: 900;
    src: local('Itau Text'), local('Itau Text'),
     url(${ItauTextPro_W_XBd_woff_1.default}) format('woff2'),
      url(${ItauTextPro_W_XBd_woff2_1.default}) format('woff');
  }

  @font-face {
    font-display: swap;
    font-family: 'Itau Display';
    font-style: 'light';
    font-weight: 200;
    src: local('Itau Display'), local('Itau Display'),
      url(${ItauDisplayPro_W_Lt_woff_1.default}) format('woff2'),
      url(${ItauDisplayPro_W_Lt_woff2_1.default}) format('woff');
  }

  @font-face {
    font-display: swap;
    font-family: 'Itau Display';
    font-style: 'regular';
    font-weight: 400;
    src: local('Itau Display'), local('Itau Display'),
      url(${ItauDisplayPro_W_Rg_woff_1.default}) format('woff2'),
      url(${ItauDisplayPro_W_Rg_woff2_1.default}) format('woff');
  }

  @font-face {
    font-family: 'Itau Display';
    font-style: 'bold';
    font-weight: 700;
    src: local('Itau Display'), local('Itau Display'),
      url(${ItauDisplayPro_W_Bd_woff_1.default}) format('woff2'),
      url(${ItauDisplayPro_W_Bd_woff2_1.default}) format('woff');
  }

  @font-face {
    font-display: swap;
    font-family: 'Itau Display';
    font-style: 'xbold';
    font-weight: 900;
    src: local('Itau Display'), local('Itau Display'),
     url(${ItauDisplayPro_W_XBd_woff_1.default}) format('woff2'),
      url(${ItauDisplayPro_W_XBd_woff2_1.default}) format('woff');
  }

  html { font-family: "Itau Text", sans-serif; font-size: 16px }

  body {
    background: ${defaultTheme.icarros.color.backgrounds.ids_color_bg_base};
    color: ${defaultTheme.icarros.color.text.body.ids_color_text_body_01};
  }

  a {
    text-decoration: none;
  }
`;
//# sourceMappingURL=index.js.map